import type { WebhookLogsState } from './state';

export default {
  setFilters: (
    state: WebhookLogsState,
    action: { payload: Partial<WebhookLogsState['filters']> },
  ) => ({
    ...state,
    filters: {
      ...state.filters,
      ...action.payload,
    },
  }),

  setOptions: (
    state: WebhookLogsState,
    action: { payload: Partial<WebhookLogsState['options']> },
  ) => ({
    ...state,
    options: {
      ...state.options,
      ...action.payload,
    },
  }),
};
